import React from "react";

const ConfirmDiscardModal = ({ open, onCancel, onDiscard }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white text-start p-6 rounded-lg shadow-lg max-w-sm w-full">
        <h2 className="text-lg font-semibold mb-3">Discard Changes?</h2>

        <p className="text-gray-700 mb-6">
          You have unsaved changes. Are you sure you want to close without saving?
        </p>

        <div className="flex justify-end gap-3">
          <button
            className="px-4 py-1 rounded border"
            onClick={onCancel}
          >
            Cancel
          </button>

          <button
            className="px-4 py-1 rounded bg-red-600 text-white"
            onClick={onDiscard}
          >
            Discard
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDiscardModal;
